import { render, staticRenderFns } from "./SettingBot.vue?vue&type=template&id=c8905586&scoped=true&"
import script from "./SettingBot.vue?vue&type=script&lang=js&"
export * from "./SettingBot.vue?vue&type=script&lang=js&"
import style0 from "./SettingBot.vue?vue&type=style&index=0&id=c8905586&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8905586",
  null
  
)

export default component.exports